import { useDatabase } from '../composables/database'

type UserModelReturn = {
  clearUsersData: () => Promise<void>
  getUserData: () => Promise<unknown | void>
  writeUsersData: (data: any) => Promise<void>
}
export const UserModel = (): UserModelReturn => {
  const { run, query } = useDatabase()
  const getUserData = async () => {
    const sql = `
    SELECT * FROM user;
    `
    return await query(sql)
      .catch((error) => console.log(`Error loading User's data: ${error}`))
      .then((userData) => {
        if (typeof userData !== undefined && userData && userData.length > 0) {
          return JSON.parse(userData[0]['users_data'])
        } else {
          return null
        }
      })
  }

  const writeUsersData = async (data: any) => {
    const sql = `
        INSERT OR REPLACE INTO user (id, users_data)
        VALUES (0, ?);
    `
    await run(sql, [JSON.stringify(data)]).catch((error) => {
      console.log(`Error writing user data: ${error}`)
    })
  }

  const clearUsersData = async () => {
    const sql = 'DELETE FROM user;'
    await run(sql, []).catch((error) => `Error deleting users: ${error}`)
  }
  return {
    getUserData,
    writeUsersData,
    clearUsersData,
  }
}
